export default angular
  .module('st.Integrations.CoreLogic', [])
  .service('coreLogicService', ($http, dataService, CORE_LOGIC) => ({
    rpDataAuthenticate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CORE_LOGIC.API.RP_DATA_AUTHENTICATE,
        { params }
      ),
    rpDataDeauthenticate: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CORE_LOGIC.API.RP_DATA_DEAUTHENTICATE,
        { params }
      ),
    rpDataPropertyDetails: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CORE_LOGIC.API.RP_DATA_PROPERTY_DETAILS,
        { params }
      ),
    rpDataPropertyReport: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CORE_LOGIC.API.RP_DATA_PROPERTY_REPORT,
        { params }
      ),
    rpDataPropertySearch: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CORE_LOGIC.API.RP_DATA_PROPERTY_SEARCH,
        { params }
      ),
    rpDataPropertyUrl: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        CORE_LOGIC.API.RP_DATA_PROPERTY_URL,
        { params }
      )
  }))
  .constant('CORE_LOGIC', {
    API: {
      RP_DATA_AUTHENTICATE: '/api/v1/integrations/core-logic/rp-data-authenticate',
      RP_DATA_DEAUTHENTICATE: '/api/v1/integrations/core-logic/rp-data-deauthenticate',
      RP_DATA_PROPERTY_DETAILS: '/api/v1/integrations/core-logic/rp-data-property-details',
      RP_DATA_PROPERTY_REPORT: '/api/v1/integrations/core-logic/rp-data-property-report',
      RP_DATA_PROPERTY_SEARCH: '/api/v1/integrations/core-logic/rp-data-property-search',
      RP_DATA_PROPERTY_URL: '/api/v1/integrations/core-logic/rp-data-property-url'
    }
  });
